import { httpCountStats } from "api/dashboard";
import "Assets/styles/css/layout.css";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";
import { privateRoutes } from "routes/routes";
import SideBarLogo from "../../Assets/img/Pavelify.png";
function Sidebar({ active }) {
  const {
    data: {
      stats: { onlineVisitor, emailCount, unreadChats }
    }
  } = useQuery("countStats", () => httpCountStats(), {
    initialData: {
      stats: {
        onlineVisitor: 0,
        emailCount: 0,
        unreadChats: 0
      }
    }
  });

  return (
    <div className="Sidebar">
      <img src={SideBarLogo} alt="" />
      <nav>
        <li className={`${active === "home" && "active"}`}>
          <Link to={privateRoutes.dashboard}>
            <svg
              width="34"
              height="34"
              viewBox="0 0 34 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M29.5093 11.3474L20.2301 3.92411C18.4168 2.47911 15.5834 2.46494 13.7843 3.90994L4.50511 11.3474C3.17344 12.4099 2.36594 14.5349 2.64928 16.2066L4.43428 26.8883C4.84511 29.2824 7.06928 31.1666 9.49178 31.1666H24.5084C26.9026 31.1666 29.1693 29.2399 29.5801 26.8741L31.3651 16.1924C31.6201 14.5349 30.8126 12.4099 29.5093 11.3474ZM18.0626 25.4999C18.0626 26.0808 17.5809 26.5624 17.0001 26.5624C16.4193 26.5624 15.9376 26.0808 15.9376 25.4999V21.2499C15.9376 20.6691 16.4193 20.1874 17.0001 20.1874C17.5809 20.1874 18.0626 20.6691 18.0626 21.2499V25.4999Z"
                fill="#6A7097"
              />
            </svg>
          </Link>
        </li>

        <li className={`${active === "LiveChat" && "active"}`}>
          <Link to={privateRoutes.liveChat}>
            <svg
              width="34"
              height="34"
              viewBox="0 0 34 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M26.1658 23.8425L26.7183 28.3192C26.86 29.495 25.5992 30.3167 24.5933 29.7075L19.6917 26.7892C19.3517 26.5908 19.2667 26.1658 19.4508 25.8258C20.1592 24.5225 20.5417 23.0492 20.5417 21.5758C20.5417 16.3908 16.0933 12.1692 10.625 12.1692C9.50584 12.1692 8.415 12.3392 7.395 12.6792C6.87084 12.8492 6.36084 12.3675 6.48834 11.8292C7.7775 6.67251 12.7358 2.83334 18.6575 2.83334C25.5708 2.83334 31.1667 8.06084 31.1667 14.5067C31.1667 18.3317 29.1975 21.7175 26.1658 23.8425Z"
                fill="#6A7097"
              />
              <path
                d="M18.4167 21.5758C18.4167 23.2617 17.7933 24.82 16.745 26.0525C15.3425 27.7525 13.1183 28.8433 10.625 28.8433L6.92751 31.0392C6.30418 31.4217 5.51084 30.8975 5.59584 30.175L5.95001 27.3842C4.05168 26.0667 2.83334 23.9558 2.83334 21.5758C2.83334 19.0825 4.16501 16.8867 6.20501 15.5833C7.46584 14.7617 8.98168 14.2942 10.625 14.2942C14.9317 14.2942 18.4167 17.5525 18.4167 21.5758Z"
                fill="#6A7097"
              />
            </svg>
            {unreadChats > 0 ? <span className="badgeCount">{unreadChats}</span> : null}
          </Link>
        </li>

        <li className={`${active === "EmailTickets" && "active"}`}>
          <Link to={privateRoutes.emailTickets}>
            <svg
              width="34"
              height="34"
              viewBox="0 0 34 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M24.0833 4.95831H9.91668C5.66668 4.95831 2.83334 7.08331 2.83334 12.0416V21.9583C2.83334 26.9166 5.66668 29.0416 9.91668 29.0416H24.0833C28.3333 29.0416 31.1667 26.9166 31.1667 21.9583V12.0416C31.1667 7.08331 28.3333 4.95831 24.0833 4.95831ZM24.7492 13.5858L20.315 17.1275C19.38 17.8783 18.19 18.2466 17 18.2466C15.81 18.2466 14.6058 17.8783 13.685 17.1275L9.25084 13.5858C8.79751 13.2175 8.72668 12.5375 9.08084 12.0841C9.44918 11.6308 10.115 11.5458 10.5683 11.9141L15.0025 15.4558C16.0792 16.32 17.9067 16.32 18.9833 15.4558L23.4175 11.9141C23.8708 11.5458 24.5508 11.6166 24.905 12.0841C25.2733 12.5375 25.2025 13.2175 24.7492 13.5858Z"
                fill="#6A7097"
              />
            </svg>
            {emailCount > 0 ? <span className="badgeCount">{emailCount}</span> : null}
          </Link>
        </li>

        <li className={`${active === "calender" && "active"}`}>
          <Link to={privateRoutes.calendarBooking}>
            <svg
              width="34"
              height="34"
              viewBox="0 0 34 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M23.7292 5.04331V2.83331C23.7292 2.25248 23.2475 1.77081 22.6667 1.77081C22.0858 1.77081 21.6042 2.25248 21.6042 2.83331V4.95831H12.3958V2.83331C12.3958 2.25248 11.9142 1.77081 11.3333 1.77081C10.7525 1.77081 10.2708 2.25248 10.2708 2.83331V5.04331C6.44584 5.39748 4.59001 7.67831 4.30668 11.0641C4.27834 11.475 4.61834 11.815 5.01501 11.815H28.985C29.3958 11.815 29.7358 11.4608 29.6933 11.0641C29.41 7.67831 27.5542 5.39748 23.7292 5.04331Z"
                fill="#6A7097"
              />
              <path
                d="M28.3333 13.94H5.66667C4.8875 13.94 4.25 14.5775 4.25 15.3567V24.0833C4.25 28.3333 6.375 31.1667 11.3333 31.1667H18.3175C19.295 31.1667 19.975 30.2175 19.6633 29.2967C19.38 28.475 19.1392 27.5683 19.1392 26.9167C19.1392 22.6242 22.6383 19.125 26.9308 19.125C27.3417 19.125 27.7525 19.1533 28.1492 19.2242C28.9992 19.3517 29.7642 18.6858 29.7642 17.8358V15.3708C29.75 14.5775 29.1125 13.94 28.3333 13.94ZM13.0475 25.0892C12.9058 25.2167 12.75 25.3158 12.58 25.3867C12.41 25.4575 12.2258 25.5 12.0417 25.5C11.8575 25.5 11.6733 25.4575 11.5033 25.3867C11.3333 25.3158 11.1775 25.2167 11.0358 25.0892C10.7808 24.82 10.625 24.4517 10.625 24.0833C10.625 23.9983 10.6392 23.8992 10.6533 23.8142C10.6675 23.715 10.6958 23.63 10.7383 23.545C10.7667 23.46 10.8092 23.375 10.8658 23.29C10.9083 23.2192 10.9792 23.1483 11.0358 23.0775C11.1775 22.95 11.3333 22.8508 11.5033 22.78C11.8433 22.6383 12.24 22.6383 12.58 22.78C12.75 22.8508 12.9058 22.95 13.0475 23.0775C13.1042 23.1483 13.175 23.2192 13.2175 23.29C13.2742 23.375 13.3167 23.46 13.345 23.545C13.3875 23.63 13.4158 23.715 13.43 23.8142C13.4442 23.8992 13.4583 23.9983 13.4583 24.0833C13.4583 24.4517 13.3025 24.82 13.0475 25.0892ZM13.0475 20.1308C12.9058 20.2583 12.75 20.3575 12.58 20.4283C12.41 20.4992 12.2258 20.5417 12.0417 20.5417C11.8575 20.5417 11.6733 20.4992 11.5033 20.4283C11.3192 20.3575 11.1775 20.2583 11.0358 20.1308C10.7808 19.8617 10.625 19.4933 10.625 19.125C10.625 18.7567 10.7808 18.3883 11.0358 18.1192C11.1775 17.9917 11.3333 17.8925 11.5033 17.8217C11.8433 17.68 12.24 17.68 12.58 17.8217C12.75 17.8925 12.9058 17.9917 13.0475 18.1192C13.1042 18.19 13.175 18.2608 13.2175 18.3317C13.2742 18.4167 13.3167 18.5017 13.345 18.5867C13.3875 18.6717 13.4158 18.7567 13.43 18.8417C13.4442 18.9408 13.4583 19.04 13.4583 19.125C13.4583 19.4933 13.3025 19.8617 13.0475 20.1308ZM18.0058 20.1308C17.7367 20.3858 17.3825 20.5417 17 20.5417C16.8158 20.5417 16.6317 20.4992 16.4617 20.4283C16.2775 20.3575 16.1358 20.2583 15.9942 20.1308C15.7392 19.8617 15.5833 19.4933 15.5833 19.125C15.5833 19.04 15.5975 18.9408 15.6117 18.8417C15.6258 18.7567 15.6542 18.6717 15.6967 18.5867C15.725 18.5017 15.7675 18.4167 15.8242 18.3317C15.8808 18.2608 15.9375 18.19 15.9942 18.1192C16.5183 17.595 17.4675 17.595 18.0058 18.1192C18.0625 18.19 18.1192 18.2608 18.1758 18.3317C18.2325 18.4167 18.275 18.5017 18.3033 18.5867C18.3458 18.6717 18.3742 18.7567 18.3883 18.8417C18.4025 18.9408 18.4167 19.04 18.4167 19.125C18.4167 19.4933 18.2608 19.8617 18.0058 20.1308Z"
                fill="#6A7097"
              />
              <path
                d="M30.9258 22.9075C28.7158 20.6975 25.1175 20.6975 22.9075 22.9075C20.6975 25.1175 20.6975 28.7158 22.9075 30.9258C25.1175 33.1358 28.7158 33.1358 30.9258 30.9258C33.1358 28.7158 33.1358 25.1175 30.9258 22.9075ZM29.8492 27.71C29.665 27.9083 29.3958 28.0217 29.0983 28.0217H28.05V29.1267C28.05 29.4242 27.9367 29.6792 27.7383 29.8775C27.54 30.0758 27.285 30.1892 26.9875 30.1892C26.4067 30.1892 25.925 29.7075 25.925 29.1267V28.0217H24.8625C24.2817 28.0217 23.8 27.5542 23.8 26.9592C23.8 26.3783 24.2817 25.8967 24.8625 25.8967H25.925V24.8908C25.925 24.31 26.3925 23.8283 26.9875 23.8283C27.5683 23.8283 28.05 24.31 28.05 24.8908V25.8967H29.0983C29.6933 25.8967 30.1608 26.3783 30.1608 26.9592C30.1608 27.2567 30.0475 27.5258 29.8492 27.71Z"
                fill="#6A7097"
              />
            </svg>
          </Link>
        </li>

        <li className={`${active === "LiveVisitor" && "active"}`}>
          <Link to={privateRoutes.liveVisitors}>
            <svg
              width="34"
              height="34"
              viewBox="0 0 34 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M24.8342 11.0075C24.735 10.9933 24.6358 10.9933 24.5367 11.0075C22.3408 10.9366 20.5983 9.13748 20.5983 6.92748C20.5983 4.67498 22.4258 2.83331 24.6925 2.83331C26.945 2.83331 28.7867 4.66081 28.7867 6.92748C28.7725 9.13748 27.03 10.9366 24.8342 11.0075Z"
                fill="#6A7097"
              />
              <path
                d="M29.4525 20.825C27.8658 21.8875 25.6417 22.2841 23.5875 22.015C24.1258 20.8533 24.4092 19.5641 24.4233 18.2041C24.4233 16.7875 24.1117 15.4416 23.5167 14.2658C25.6133 13.9825 27.8375 14.3791 29.4383 15.4416C31.6767 16.915 31.6767 19.3375 29.4525 20.825Z"
                fill="#6A7097"
              />
              <path
                d="M9.12333 11.0075C9.2225 10.9933 9.32166 10.9933 9.42083 11.0075C11.6167 10.9366 13.3592 9.13748 13.3592 6.92748C13.3592 4.66081 11.5317 2.83331 9.265 2.83331C7.0125 2.83331 5.185 4.66081 5.185 6.92748C5.185 9.13748 6.9275 10.9366 9.12333 11.0075Z"
                fill="#6A7097"
              />
              <path
                d="M9.27915 18.2042C9.27915 19.5783 9.57665 20.8817 10.115 22.0575C8.11748 22.27 6.03498 21.845 4.50498 20.8392C2.26665 19.3517 2.26665 16.9292 4.50498 15.4417C6.02082 14.4217 8.15998 14.0108 10.1717 14.2375C9.59082 15.4275 9.27915 16.7733 9.27915 18.2042Z"
                fill="#6A7097"
              />
              <path
                d="M17.17 22.4825C17.0567 22.4683 16.9292 22.4683 16.8017 22.4825C14.195 22.3975 12.1125 20.2583 12.1125 17.6233C12.1267 14.9317 14.2942 12.75 17 12.75C19.6917 12.75 21.8733 14.9317 21.8733 17.6233C21.8592 20.2583 19.7908 22.3975 17.17 22.4825Z"
                fill="#6A7097"
              />
              <path
                d="M12.5658 25.415C10.4267 26.8458 10.4267 29.1975 12.5658 30.6142C15.0025 32.2433 18.9975 32.2433 21.4342 30.6142C23.5733 29.1833 23.5733 26.8317 21.4342 25.415C19.0117 23.7858 15.0167 23.7858 12.5658 25.415Z"
                fill="#6A7097"
              />
            </svg>
            {onlineVisitor > 0 ? <span className="badgeCount">{onlineVisitor}</span> : null}
          </Link>
        </li>

        <li className={`${active === "contact" && "active"}`}>
          <Link to={privateRoutes.contacts}>
            <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.9358 0.833313H9.06418C3.90751 0.833313 0.833344 3.90748 0.833344 9.06415V20.9358C0.833344 24.9166 2.66084 27.6508 5.87668 28.685C6.81168 29.0108 7.88834 29.1666 9.06418 29.1666H20.9358C22.1117 29.1666 23.1883 29.0108 24.1233 28.685C27.3392 27.6508 29.1667 24.9166 29.1667 20.9358V9.06415C29.1667 3.90748 26.0925 0.833313 20.9358 0.833313ZM27.0417 20.9358C27.0417 23.9675 25.8517 25.88 23.4575 26.6733C22.0833 23.9675 18.825 22.0408 15 22.0408C11.175 22.0408 7.93084 23.9533 6.54251 26.6733H6.52834C4.16251 25.9083 2.95834 23.9816 2.95834 20.95V9.06415C2.95834 5.06915 5.06918 2.95831 9.06418 2.95831H20.9358C24.9308 2.95831 27.0417 5.06915 27.0417 9.06415V20.9358Z"
                fill="#6A7097"
              />
              <path
                d="M15 9.33331C12.195 9.33331 9.92834 11.6 9.92834 14.405C9.92834 17.21 12.195 19.4908 15 19.4908C17.805 19.4908 20.0717 17.21 20.0717 14.405C20.0717 11.6 17.805 9.33331 15 9.33331Z"
                fill="#6A7097"
              />
            </svg>
          </Link>
        </li>

        <li className={`${active === "help_desk" && "active"}`}>
          <Link to={privateRoutes.helpDesk}>
            <svg
              width="34"
              height="34"
              viewBox="0 0 34 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M28.475 9.83165C28.475 10.5966 28.0642 11.2908 27.4125 11.645L24.9475 12.9766L22.8508 14.0958L18.5017 16.4475C18.0342 16.7025 17.5242 16.83 17 16.83C16.4758 16.83 15.9658 16.7025 15.4983 16.4475L6.58749 11.645C5.93583 11.2908 5.52499 10.5966 5.52499 9.83165C5.52499 9.06665 5.93583 8.37248 6.58749 8.01831L9.37833 6.51665L11.6025 5.31248L15.4983 3.21581C16.4333 2.70581 17.5667 2.70581 18.5017 3.21581L27.4125 8.01831C28.0642 8.37248 28.475 9.06665 28.475 9.83165Z"
                fill="#6A7097"
              />
              <path
                d="M14.025 18.1192L5.7375 13.9825C5.1 13.6567 4.36333 13.6992 3.75417 14.0675C3.145 14.4358 2.79083 15.0875 2.79083 15.7958V23.63C2.79083 24.99 3.54167 26.2083 4.76 26.8175L13.0475 30.9542C13.3308 31.0958 13.6425 31.1667 13.9542 31.1667C14.3225 31.1667 14.6908 31.0675 15.0167 30.855C15.6258 30.4867 15.98 29.835 15.98 29.1267V21.2925C15.9942 19.9467 15.2433 18.7283 14.025 18.1192Z"
                fill="#6A7097"
              />
              <path
                d="M31.2092 15.7958V23.63C31.2092 24.9758 30.4583 26.1942 29.24 26.8033L20.9525 30.9542C20.6692 31.0958 20.3575 31.1667 20.0458 31.1667C19.6775 31.1667 19.3092 31.0675 18.9692 30.855C18.3742 30.4867 18.0058 29.835 18.0058 29.1267V21.3067C18.0058 19.9467 18.7567 18.7283 19.975 18.1192L23.0208 16.6033L25.1458 15.5408L28.2625 13.9825C28.9 13.6567 29.6367 13.685 30.2458 14.0675C30.8408 14.4358 31.2092 15.0875 31.2092 15.7958Z"
                fill="#6A7097"
              />
              <path
                d="M24.9475 12.9767L22.8508 14.0958L9.37833 6.51667L11.6025 5.3125L24.6075 12.6508C24.7492 12.7358 24.8625 12.8492 24.9475 12.9767Z"
                fill="#6A7097"
              />
              <path
                d="M25.1458 15.5408V18.7567C25.1458 19.3375 24.6642 19.8192 24.0833 19.8192C23.5025 19.8192 23.0208 19.3375 23.0208 18.7567V16.6033L25.1458 15.5408Z"
                fill="#6A7097"
              />
            </svg>
          </Link>
        </li>

        <li className={`${active === "Analytics" && "active"}`}>
          <Link to={privateRoutes.analytics}>
            <svg
              width="34"
              height="34"
              viewBox="0 0 34 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.936 2.83325H11.0643C5.90766 2.83325 2.8335 5.90742 2.8335 11.0641V22.9216C2.8335 28.0924 5.90766 31.1666 11.0643 31.1666H22.9218C28.0785 31.1666 31.1527 28.0924 31.1527 22.9358V11.0641C31.1668 5.90742 28.0927 2.83325 22.936 2.83325ZM10.8093 25.7124C10.8093 26.2933 10.3277 26.7749 9.74683 26.7749C9.166 26.7749 8.68433 26.2933 8.68433 25.7124V22.7799C8.68433 22.1991 9.166 21.7174 9.74683 21.7174C10.3277 21.7174 10.8093 22.1991 10.8093 22.7799V25.7124ZM18.0627 25.7124C18.0627 26.2933 17.581 26.7749 17.0002 26.7749C16.4193 26.7749 15.9377 26.2933 15.9377 25.7124V19.8333C15.9377 19.2524 16.4193 18.7708 17.0002 18.7708C17.581 18.7708 18.0627 19.2524 18.0627 19.8333V25.7124ZM25.316 25.7124C25.316 26.2933 24.8343 26.7749 24.2535 26.7749C23.6727 26.7749 23.191 26.2933 23.191 25.7124V16.9008C23.191 16.3199 23.6727 15.8383 24.2535 15.8383C24.8343 15.8383 25.316 16.3199 25.316 16.9008V25.7124ZM25.316 12.4241C25.316 13.0049 24.8343 13.4866 24.2535 13.4866C23.6727 13.4866 23.191 13.0049 23.191 12.4241V11.0499C19.5785 14.7616 15.0593 17.3824 10.0018 18.6433C9.91683 18.6716 9.83183 18.6716 9.74683 18.6716C9.26516 18.6716 8.84016 18.3458 8.71266 17.8641C8.571 17.2974 8.911 16.7166 9.49183 16.5749C14.266 15.3849 18.516 12.8774 21.8877 9.33575H20.1168C19.536 9.33575 19.0543 8.85409 19.0543 8.27325C19.0543 7.69242 19.536 7.21075 20.1168 7.21075H24.2677C24.3243 7.21075 24.3668 7.23909 24.4235 7.23909C24.4943 7.25325 24.5652 7.25325 24.636 7.28159C24.7068 7.30992 24.7635 7.35242 24.8343 7.39492C24.8768 7.42325 24.9193 7.43742 24.9618 7.46575C24.976 7.47992 24.976 7.49409 24.9902 7.49409C25.0468 7.55075 25.0893 7.60742 25.1318 7.66409C25.1743 7.72075 25.2168 7.76325 25.231 7.81992C25.2593 7.87659 25.2593 7.93325 25.2735 8.00409C25.2877 8.07492 25.316 8.14575 25.316 8.23075C25.316 8.24492 25.3302 8.25909 25.3302 8.27325V12.4241H25.316Z"
                fill="#6A7097"
              />
            </svg>
          </Link>
        </li>
        <li className={`${active === "operators" && "active"}`}>
          <Link to={privateRoutes.operators}>
            <svg
              width="35"
              height="34"
              viewBox="0 0 35 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M25.565 2.83331H8.565C6.21334 2.83331 4.315 4.71748 4.315 7.04081V22.4966C4.315 24.82 6.21334 26.7183 8.565 26.7183H9.64167C10.7608 26.7183 11.8517 27.1575 12.645 27.9508L15.0675 30.345C16.1725 31.4358 17.9575 31.4358 19.0625 30.345L21.485 27.9508C22.2783 27.1575 23.3692 26.7183 24.4883 26.7183H25.565C27.9167 26.7183 29.815 24.82 29.815 22.4966V7.04081C29.815 4.71748 27.9167 2.83331 25.565 2.83331ZM17.065 7.86248C18.595 7.86248 19.8275 9.10915 19.8275 10.625C19.8275 12.1266 18.6375 13.3308 17.1642 13.3875C17.1075 13.3875 17.0225 13.3875 16.9517 13.3875C15.4642 13.3308 14.2883 12.1266 14.2883 10.625C14.3025 9.10915 15.535 7.86248 17.065 7.86248ZM20.9608 20.8108C18.8217 22.2416 15.3083 22.2416 13.1692 20.8108C11.285 19.5641 11.285 17.4958 13.1692 16.235C15.3225 14.8041 18.8358 14.8041 20.9608 16.235C22.845 17.4958 22.845 19.55 20.9608 20.8108Z"
                fill="#6A7097"
              />
            </svg>
          </Link>
        </li>
        <li className={`${active === "settings" && "active"}`}>
          <Link to={privateRoutes.settings}>
            <svg
              width="34"
              height="34"
              viewBox="0 0 34 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M28.4749 13.0616C25.9108 13.0616 24.8624 11.2483 26.1374 9.02412C26.8741 7.73495 26.4349 6.09162 25.1458 5.35495L22.6949 3.95245C21.5758 3.28662 20.1308 3.68328 19.4649 4.80245L19.3091 5.07162C18.0341 7.29578 15.9374 7.29578 14.6483 5.07162L14.4924 4.80245C13.8549 3.68328 12.4099 3.28662 11.2908 3.95245L8.83992 5.35495C7.55075 6.09162 7.11159 7.74912 7.84825 9.03828C9.13742 11.2483 8.08909 13.0616 5.52492 13.0616C4.05159 13.0616 2.83325 14.2658 2.83325 15.7533V18.2466C2.83325 19.72 4.03742 20.9383 5.52492 20.9383C8.08909 20.9383 9.13742 22.7516 7.84825 24.9758C7.11159 26.2649 7.55075 27.9083 8.83992 28.645L11.2908 30.0475C12.4099 30.7133 13.8549 30.3166 14.5208 29.1975L14.6766 28.9283C15.9516 26.7041 18.0483 26.7041 19.3374 28.9283L19.4933 29.1975C20.1591 30.3166 21.6041 30.7133 22.7233 30.0475L25.1741 28.645C26.4633 27.9083 26.9024 26.2508 26.1658 24.9758C24.8766 22.7516 25.9249 20.9383 28.4891 20.9383C29.9624 20.9383 31.1808 19.7341 31.1808 18.2466V15.7533C31.1666 14.28 29.9624 13.0616 28.4749 13.0616ZM16.9999 21.6041C14.4641 21.6041 12.3958 19.5358 12.3958 17C12.3958 14.4641 14.4641 12.3958 16.9999 12.3958C19.5358 12.3958 21.6041 14.4641 21.6041 17C21.6041 19.5358 19.5358 21.6041 16.9999 21.6041Z"
                fill="#6A7097"
              />
            </svg>
          </Link>
        </li>
      </nav>

      <div className="logout-area">
        <Link to={privateRoutes.logout}>
          <svg
            width="34"
            height="34"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.1633 17.0992C11.1633 16.5184 11.645 16.0367 12.2258 16.0367H19.9892V4.05171C19.975 3.37171 19.4367 2.83337 18.7567 2.83337C10.4125 2.83337 4.59 8.65587 4.59 17C4.59 25.3442 10.4125 31.1667 18.7567 31.1667C19.4225 31.1667 19.975 30.6284 19.975 29.9484V18.1475H12.2258C11.6308 18.1617 11.1633 17.68 11.1633 17.0992Z"
              fill="#E74C3C"
            />
            <path
              d="M29.0983 16.3483L25.075 12.3108C24.6642 11.9 23.9842 11.9 23.5733 12.3108C23.1625 12.7216 23.1625 13.4016 23.5733 13.8125L25.7833 16.0225H19.975V18.1475H25.7692L23.5592 20.3575C23.1483 20.7683 23.1483 21.4483 23.5592 21.8591C23.7717 22.0716 24.0408 22.1708 24.31 22.1708C24.5792 22.1708 24.8483 22.0716 25.0608 21.8591L29.0842 17.8216C29.5092 17.425 29.5092 16.7591 29.0983 16.3483Z"
              fill="#E74C3C"
            />
          </svg>
        </Link>
      </div>
    </div>
  );
}

export default Sidebar;
